import React, { useState } from 'react';
import Editor from 'react-simple-code-editor';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { connect } from 'react-redux';
import { oneDark, oneLight } from 'react-syntax-highlighter/dist/esm/styles/prism';
import cn from 'classnames';
import highlighter from './Highlighter.module.scss';

const styles = {
  root: {
    // boxSizing: 'border-box',
    fontFamily: '"Dank Mono", "Fira Code", monospace',
    fontSize: '12px',
    lineHeight: '18px',
  },
};

const mapStateToProps = (state) => ({
  isSwitcherOpen: state.switcher.isSwitcherOpen,
});

const TextArea = ({ value, isSwitcherOpen, onChange, ...rest }) => {
  const [code, setCode] = useState(value);

  const onValueChange = (data) => {
    setCode(data);
  };

  const highlight = (data) => (
    <SyntaxHighlighter
      showLineNumbers
      language="json"
      className={cn(
        'microlight',
        highlighter.highlighter__syntax,
        highlighter.highlighter__area,
        isSwitcherOpen && highlighter.highlighter__dark_theme
      )}
      style={isSwitcherOpen ? oneLight : oneDark}
      wrapLongLines={true}
      lineNumberStyle={{ width: '25px', minWidth: 'none', paddingRight: '10px' }}
    >
      {data}
    </SyntaxHighlighter>
  );

  return (
    <div
      className={cn(
        highlighter.highlighter__area_container,
        !isSwitcherOpen && highlighter.highlighter__caret
      )}
    >
      <Editor
        value={code}
        onValueChange={onValueChange}
        highlight={highlight}
        style={styles.root}
        textareaClassName={highlighter.highlighter__textarea}
        onChange={onChange}
        {...rest}
      />
    </div>
  );
};

export default connect(mapStateToProps)(TextArea);
